export default __webpack_public_path__ + "static/media/image-1.e2371f54.png";